import { render, staticRenderFns } from "./RequiredSign.vue?vue&type=template&id=d2a0ef6c&"
var script = {}
import style0 from "./RequiredSign.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports